const secretKey = /(?:password|passwd|secret|token|credential|authorization|cookie|totp|recovery|api[_-]?key|access[_-]?key|private[_-]?key)/i
const bearerValue = /(?:bearer\s+[a-z0-9._~-]+|sk-[a-z0-9_-]{12,}|-----BEGIN (?:[A-Z]+ )*PRIVATE KEY-----)/i

export function sanitizeAuditSnapshot(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(sanitizeAuditSnapshot)
  if (typeof value === 'string') return bearerValue.test(value) ? '[conteúdo protegido]' : value
  if (!value || typeof value !== 'object') return value
  return Object.fromEntries(Object.entries(value as Record<string, unknown>).map(([key, nested]) => [
    key,
    secretKey.test(key) ? '[conteúdo protegido]' : sanitizeAuditSnapshot(nested),
  ]))
}
